'use client';

import { useEffect, useState, type ReactNode } from 'react';

/**
 * Renders its children on the web (so they're in the SSR HTML and crawlable
 * by Google) but removes them inside the native Capacitor app — used to keep
 * the SEO footer out of the mobile app, which has no use for marketing /
 * cross-island landing links.
 *
 * SSR renders children (native check is browser-only) → links are in the
 * served HTML for crawlers ; on iOS/Android the effect drops them after
 * mount.
 */
export function HideOnNative({ children }: { children: ReactNode }) {
  const [isNative, setIsNative] = useState(false);

  useEffect(() => {
    let alive = true;
    import('@capacitor/core')
      .then(({ Capacitor }) => {
        if (alive && Capacitor.isNativePlatform()) setIsNative(true);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (isNative) return null;
  return <>{children}</>;
}
